import { OnInit, OnDestroy } from '@angular/core';
import { AuthService } from "../services/auth.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from 'app/shared/services/alert.service';
import { AmplifyService } from 'aws-amplify-angular';
import { DacConfig } from 'app/shared/services/dac-config.service';
var AdminLoginComponent = /** @class */ (function () {
    function AdminLoginComponent(authService, router, alertService, route, dacConfig, amplifyService) {
        var _this = this;
        this.authService = authService;
        this.router = router;
        this.alertService = alertService;
        this.route = route;
        this.dacConfig = dacConfig;
        this.amplifyService = amplifyService;
        this.return = '';
        this._forgotPasswordCodeSent = false;
        this.showSignIn = true;
        this.isAuthenticating = false;
        this._authSubscription = this.amplifyService.authStateChange$.subscribe(function (authState) {
            _this._authState = authState.state;
            // we don't want to show the greetings while we log a user in.
            _this.showSignIn = authState.state === 'signIn' || authState.state === 'signedIn';
            _this.user = authState.user;
            if (authState.state === 'signedIn') {
                _this.authenticateCognito(); // make sure we are setup in our session on the server...
            }
        });
    }
    AdminLoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams
            .subscribe(function (params) { return _this.return = params['return'] || '/admin/'; });
    };
    AdminLoginComponent.prototype.ngOnDestroy = function () {
        if (this._authSubscription) {
            this._authSubscription.unsubscribe();
        }
    };
    AdminLoginComponent.prototype.handleSubmit = function (event) {
        if (event && event.charCode === 13) {
            this.login();
        }
    };
    Object.defineProperty(AdminLoginComponent.prototype, "username", {
        get: function () {
            return this._username;
        },
        set: function (v) {
            this._username = v ? v.toLowerCase() : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdminLoginComponent.prototype, "supportEmail", {
        get: function () {
            return this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdminLoginComponent.prototype, "authState", {
        get: function () {
            return this._authState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdminLoginComponent.prototype, "sentCode", {
        // FOLLOWING FUNCTIONALITY FOR Forgot Password
        get: function () {
            return this._forgotPasswordCodeSent;
        },
        enumerable: true,
        configurable: true
    });
    AdminLoginComponent.prototype.triggerForgotPassword = function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this._forgotPasswordCodeSent = false;
        this.amplifyService.setAuthState({ state: 'forgotPassword', user: this.user });
        return false;
    };
    AdminLoginComponent.prototype.goBackToSignIn = function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.amplifyService.setAuthState({ state: 'signIn', user: this.user });
        return false;
    };
    AdminLoginComponent.prototype.sendForgotPasswordCode = function (evt) {
        var _this = this;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        var username = this.username;
        if (!username) {
            this.alertService.error("You must enter an email address");
            return;
        }
        // we first attempt to migrate the user before initiating the forgot password
        this.isAuthenticating = true;
        this.authService.migrateCognito(username)
            .then(function () {
            _this.amplifyService
                .auth()
                .forgotPassword(username)
                .then(function () {
                _this._forgotPasswordCodeSent = true;
                _this.isAuthenticating = false;
                _this.alertService.info("Confirmation Code sent to the email address you entered");
            })
                .catch(function (err) {
                _this.isAuthenticating = false;
                _this.alertService.error(err.message);
                console.error(err);
                _this._forgotPasswordCodeSent = false;
            });
        })
            .catch(function (err) {
            _this.isAuthenticating = false;
            _this.alertService.error("An error occurred.  Please check your internet connection or contact support");
            console.error(err);
            _this._forgotPasswordCodeSent = false;
        });
        return false;
    };
    AdminLoginComponent.prototype.submitForgotPassword = function () {
        var _this = this;
        if (!this.forgotPasswordCode) {
            this.alertService.error("Missing Code Confirmation");
            return;
        }
        if (!this.newPassword) {
            this.alertService.error("Missing New Password");
            return;
        }
        var errors = this.validatePasswordChange(this.newPassword);
        if (errors.length) {
            this.alertService.error(errors.join(""));
            return;
        }
        this.amplifyService.auth()
            .forgotPasswordSubmit(this.username, this.forgotPasswordCode, this.newPassword)
            .then(function () {
            _this.newPassword = null;
            _this.password = null;
            _this.user = { username: _this.username };
            _this.amplifyService.setAuthState({ state: 'signIn', user: _this.user });
            _this.alertService.success("Password reset.  Please login with your new credentials");
        })
            .catch(function (err) {
            _this.alertService.error(err.message);
        });
    };
    AdminLoginComponent.prototype.validatePasswordChange = function (password) {
        var passwordPolicyMsg = "Password must be 8 characters or more, contain at least one number(0-9), one uppercase letter(a-z), and one lowercase letter(A-Z)";
        var errors = [];
        if (!password || password.length < 8) {
            errors.push(passwordPolicyMsg);
        }
        else if (!password.match(/[0-9]+/)) {
            errors.push(passwordPolicyMsg);
        }
        else if (!password.match(/[A-Z]+/)) {
            errors.push(passwordPolicyMsg);
        }
        else if (!password.match(/[a-z]+/)) {
            errors.push(passwordPolicyMsg);
        }
        return errors;
    };
    // Functionality for require new password
    AdminLoginComponent.prototype.submitNewPassword = function () {
        var _this = this;
        if (!this.newPassword) {
            this.alertService.error("Missing Password");
            return;
        }
        var errors = this.validatePasswordChange(this.newPassword);
        if (errors.length) {
            this.alertService.error(errors.join(""));
            return;
        }
        var user = this.user;
        var requiredAttributes = user.challengeParam.requiredAttributes;
        this.isAuthenticating = true;
        this.amplifyService
            .auth()
            .completeNewPassword(user, this.newPassword, requiredAttributes)
            .then(function () {
            _this.password = null;
            _this.newPassword = null;
            _this.isAuthenticating = false;
            _this.alertService.success("Password has been updated.  Please login with your new credentials");
            _this.amplifyService.setAuthState({ state: 'signIn', user: user });
        })
            .catch(function (err) {
            _this.isAuthenticating = false;
            _this.alertService.error(err.message);
        });
    };
    // Functionality for Sign In
    AdminLoginComponent.prototype.login = function () {
        var _this = this;
        if (!this.username || this.username.trim() === "" ||
            !this.password || this.password.trim() === "") {
            this.alertService.error("Your email and password cannot be empty");
            return;
        }
        var username = this.username.trim();
        var password = this.password.trim();
        this.isAuthenticating = true;
        // TODO: stephen shouldn't this all be put into auth.server.ts?
        this.amplifyService
            .auth()
            .signIn(username, password)
            .then(function (user) {
            _this.isAuthenticating = false;
            if (user['challengeName'] === 'SMS_MFA' ||
                user['challengeName'] === 'SOFTWARE_TOKEN_MFA') {
                _this.amplifyService.setAuthState({ state: 'confirmSignIn', user: user });
            }
            else if (user['challengeName'] === 'NEW_PASSWORD_REQUIRED') {
                _this.password = ""; // clear out our password, so its not populated when the password is reset.
                _this.amplifyService.setAuthState({
                    state: 'requireNewPassword',
                    user: user,
                });
            }
            else if (user['challengeName'] === 'CUSTOM_CHALLENGE' &&
                user.challengeParam &&
                user.challengeParam.trigger === 'true') {
                _this.amplifyService.setAuthState({
                    state: 'customConfirmSignIn',
                    user: user,
                });
            }
        })
            .catch(function (error) {
            if (error && error.code == "NotAuthorizedException") {
                // we will check for a user that might not have migrated over...
                _this.migrationAuthenticate();
            }
            else {
                _this.isAuthenticating = false;
                _this.alertService.error("There was an error in communicating with the server.  Please try again or contact support");
            }
            console.error(error);
        });
    };
    AdminLoginComponent.prototype.authenticateCognito = function () {
        var _this = this;
        // 
        this.authService.authenticateCognito(this.user)
            .then(function (user) {
            _this.password = "";
            // either going back to the original requested url or going to the dashboard.
            _this.router.navigateByUrl(_this.return);
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error("There was an error in authenticating your session.  You may need to clear your browser cookies and try again or contact customer support");
            _this.alertService.error(error);
        });
    };
    AdminLoginComponent.prototype.migrationAuthenticate = function () {
        var _this = this;
        this.authService.authenticate(this.username, this.password)
            .then(function (clientId) {
            _this.password = "";
            // either going back to the original requested url or going to the dashboard.
            _this.router.navigateByUrl(_this.return);
        })
            .catch(function (error) {
            _this.isAuthenticating = false;
            _this.alertService.error(error);
            console.error(error);
        });
    };
    return AdminLoginComponent;
}());
export { AdminLoginComponent };



// WEBPACK FOOTER //
// ./src/app/login/admin-login/admin-login.component.ts.pre-build-optimizer.js